import React, {useEffect, useState} from "react";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import {useSelector, useDispatch} from "react-redux";
import {appendFilters} from "store/filter/actions"
import "./styles.scss"

const RoomFilter = ({roomsType, value, showLoading, setTopFilterError}) => {
    const filterData = useSelector(state => state.filter);
    const dispatch = useDispatch();
    const numOfRooms = filterData[roomsType]?.length > 1 ? Array.from({length: filterData[roomsType][1] > 4 ? 5 - filterData[roomsType][0] + 1 : filterData[roomsType][1]}, (_, index) => filterData[roomsType][0] + index) : filterData[roomsType]

    return (
        <> {numOfRooms?.map((itemaData, index) => {
            return (
                <span key={index}>
                        <input
                            type='checkbox'
                            className='btn-check'
                            name='room'
                            id={`room${itemaData}`}
                            autoComplete='off'
                            checked={filterData[value]?.some(item => item === itemaData)}

                            onChange={() => {
                            }}
                        />
                        <label
                            style={{
                                background: filterData[value]?.some(item => item === itemaData) ? "#0583f2" : "#f5f5f5",
                                color: filterData[value]?.some(item => item === itemaData) ? "#fff" : "#000",
                            }}
                            onClick={() => {
                                let updatedData = filterData[value];
                                const isExist = filterData[value]?.some(item => item === itemaData)
                                if(isExist){
                                    updatedData = filterData[value]?.filter(item => item !== itemaData)
                                }else{
                                    updatedData.push(itemaData)
                                }
                                setTopFilterError(false)
                                dispatch(appendFilters({[`${value}`]: [...updatedData], page: 1}))
                                showLoading()

                                // const isExist = filterData[value]?.some(item => item === itemaData)
                                // if (itemaData === filterData[value][filterData[value]?.length - 1]) {
                                //     if (!isExist) {
                                //         dispatch(appendFilters({[`${value}`]: [itemaData]}))
                                //         showLoading()
                                //     } else {
                                //         const updatedData = filterData[value]?.filter(item => item !== itemaData)
                                //         dispatch(appendFilters({[`${value}`]: [...updatedData]}))
                                //         showLoading()
                                //     }
                                //
                                // } else {
                                //     if (!isExist) {
                                //         const updatedArray = filterData[`${value}`]?.filter(item => item !== numOfRooms[numOfRooms?.length - 1])
                                //         dispatch(appendFilters({[`${value}`]: [...updatedArray, itemaData]}))
                                //         showLoading()
                                //     } else {
                                //         const updatedData = filterData[`${value}`]?.filter(item => item !== itemaData)
                                //         dispatch(appendFilters({[`${value}`]: [...updatedData]}))
                                //         showLoading()
                                //     }
                                // }
                            }}
                            className='btn btn-outline-light me-2'
                            htmlFor='btncheckType'>
                            {filterData[roomsType][1] > 5 ? itemaData < 5 ? itemaData : `+${itemaData}` : itemaData}
                             {/* {index + 1 < 5 ? itemaData : filterData[roomsType] `+${itemaData}`} */}
                        </label>
                    </span>
            )
        })}
        </>
    )
}

export default RoomFilter